import axios from 'axios';
import { clickable } from "../../utils/a11y";
import React, { useState, useRef, useEffect } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Box, IconButton, Tooltip } from '@mui/material';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import "../../styles/Admin-ui/Admin-DoctorsList.css";
import { API_DETAILS, COOKIE_KEYS } from '../../App';
import AdminSideBar from './Admin-SideBar';
import AdminPopUps from './Admin-PopUps';
import CustomToolbarEditor from '../RichTextEditor';
import Popup from 'reactjs-popup';
import { useForm } from "react-hook-form";
import { Oval } from 'react-loader-spinner';
import { toast } from '../../utils/toast';
import { useSubmitGuard } from '../../utils/useSubmitGuard';
import Youroheader from '../Youro-header';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import "../../styles/Admin-ui/Admin-Maintainence.css";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const POPUPMODES = {
    NEW: 'NEW',
    VIEW: 'VIEW',
    EDIT: 'EDIT'
}

const AdminMaintainenceList = () => {
    const [tableData, setTableData] = useState([]);
    const [renderAdmin, canRenderAdmin] = useState(false);
    const [renderapidata, cannotrenderapidata] = useState({
        prescriptionRender: true,
        diagnosisRender: true,
        questionnairesRender: true,
    });
    const [renderDiagnosisApiData, setRenderDiagnosisApiData] = useState(false);
    const [renderPrescriptionApiData, setRenderPrescriptionApiData] = useState(false);
    const [renderQuestionnaireApiData, setRenderQuestionnaireApiData] = useState(false);
    const [renderCategoryApiData, setRenderCategoryApiData] = useState(false);
    const [renderPresTypeApiData, setRenderPresTypeApiData] = useState(false);
    const [open, setOpen] = useState(false);
    const [, guard] = useSubmitGuard();
    const [popUpMode, setPopupMode] = useState(POPUPMODES.NEW);
    const [popUpData, setPopUpData] = useState({});
    const [addPopUpContext, setAddPopUpContext] = useState('');
    const isRendered = useRef(false);
    let count = 0;
    const [authContext, setAuthContext] = useState(''); // default zero. After login if ADMIN -> set('ADMIN') else if 'ASSITANT' -> set('ASSITANT')
    const [pageContext, setPageContext] = React.useState('PRESCRIPTION');
    const [prescriptionList, setPrescription] = useState([]);
    // const [diagnosisList, setDiagnoses] = useState([]);
    const [questionnairesList, setQuestionnaires] = useState([]);
    const [selecDiag, setDiag] = useState("");
    const [selecDiagInfo, setDiagInfo] = useState("");

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

    const [diagnosisData, setDiagnosisData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [presTypeData, setPresTypeData] = useState([]);
    const [needsRefresh, setRefreshStatus] = useState(false);
    const [editCategoryData, setEditCategoryData] = useState({});
    const [editPresTypeData, setEditPresTypeData] = useState({});

    const [selectedQuestionnaireId, setSelectedQuestionnaireId] = useState(null);
    const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);
    const [actionsColumnPosition, setActionsColumnPosition] = useState("last");
    const [isQuestionnaireSelected, setisQuestionnanireSelected] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [Questionnaires, setQuestionnairesUpdate] = useState([]);
    const [options, setOptions] = useState([]);
    const [isAddQuestionClicked, setIsAddQuestionClicked] = useState(false);
    const [openInnerPopUp, setOpenInnerPopUp] = useState(false);
    const inputRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState("");
    const [refetchQuestionnaire, setRefetchQuestionnaire] = useState(false);
    const [showAdminPopUps, setShowAdminPopUps] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState("");
    const [selectedDiagnosis, setSelectedDiagnosis] = useState("");
    const [optionsList, setOptionsList] = useState([]);
    const [isEditQuestionClicked, setIsEditQuestionClicked] = useState(false);
    const [questionId, setQuestionId] = useState(null);
    const [questionWeight, setQuestionWeight] = useState(null);

    const [customOptions, setCustomOptions] = useState([]);
    const [customOption, setCustomOption] = useState("");
    const [customOptionWeights, setCustomOptionWeights] = useState([]);
    const [optionWeight, setOptionWeight] = useState(null);
    const [questionOptions, setQuestionOptions] = useState([]);
    const [isFollowUp, setIsFollowUp] = useState(false);
    const [followUpQuestions, setFollowUpQuestions] = useState(new Map());
    const [parentId, setParentId] = useState(null);
    const [optionId, setOptionId] = useState(null);
    const [questionMap, setQuestionMap] = useState(new Map());
    const [isChecked, setIsChecked] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isEditQuestionnaireClicked, setIsEditQuestionnaireClicked] =
      useState(false);
    const [dropdownValue, setDropdownValue] = useState('Initial');
  
    // Add a state to force re-render
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [columns, setColumns] = useState(
        [
            // {
            //     accessorKey: 'medicineId',
            //     header: 'ID',
            //     enableColumnOrdering: false,
            //     enableEditing: false,
            //     size: 50,
            // },
            {
                accessorKey: 'presName',
                header: 'Name',
                enableColumnOrdering: false,
                enableEditing: false,
                size: 50,
            },
            {
                accessorKey: 'presType',
                header: 'Prescription Type',
            },
            {
                accessorKey: 'category',
                header: 'Category',
            },
            {
                accessorKey: 'diagnosis',
                header: 'Diagnosis',
            }
        ]
    );
      
    const handleDiagnosisChange = (event) => {
      setSelectedDiagnosis(event.target.value);
    };

    const handleCustomOptionChange = (e) => {
      setCustomOption(e.target.value);
    };
  
    const handleAddCustomOption = () => {
      if (customOption.trim() === "") {
        setErrorMessage("Enter custom option");
      } else if (optionWeight === null) {
        setErrorMessage("Enter Option Weight");
      } else if (optionWeight < 0) {
        setErrorMessage("Option Weight should be greater than or equal to zero");
      } else if (optionWeight > questionWeight) {
        setErrorMessage("Option Weight should be less than or equal to Question's weight");
      } else {
          setCustomOptions([...customOptions, customOption]);
          setCustomOptionWeights([...customOptionWeights, optionWeight]);
          setCustomOption("");
          setErrorMessage("");
          setOptionWeight(null);
      }
    };

    const handleClosePopup = () => {
      setErrorMessage("");
      setCustomOption("");
      setCustomOptions([]);
      setOptionsList([]);
      setSelectedOption("");
      setQuestionWeight(null);
      setOpenInnerPopUp(false);
      setParentId(null);
      setOptionId(null);
    };
    const handleCloseEditPopup = () => {
      setErrorMessage("");
      setCustomOption("");
      setCustomOptions([]);
      setOptionsList([]);
      setSelectedOption("");
      setIsEditQuestionClicked(false);
      setParentId(null);
      setOptionId(null);
    };

    const handleOptionChange = (event) => {
      if (event.target.value === "") {
        setOptionsList(null);
      } else {
        setOptionsList(event.target.value.split("/"));
      }
      setSelectedOption(event.target.value);
    };

    const handleQuestionnaireSelection = async (
      questionnaire_id,
      questionnaire_type
    ) => {
      setSelectedQuestionnaireId(questionnaire_id);
      setSelectedQuestionnaire(questionnaire_type);
      setisQuestionnanireSelected(true);
      setOpen(true);
      setAddPopUpContext("QUESTION");
      const url =
        API_DETAILS.baseUrl +
        API_DETAILS.PORT +
        API_DETAILS.baseExtension +
        `/getAllQuestions/${questionnaire_id}`;
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      try {
        const res = await axios.get(url, config);
        setQuestions(res.data);
        const questionGroupMap = new Map();
        res.data.forEach((question) => {
          const { qId, question: qText, parent_question_id } = question;
          if (parent_question_id !== 0) {
            if (questionGroupMap.has(parent_question_id)) {
              const existingQuestions = questionGroupMap.get(parent_question_id);
              questionGroupMap.set(parent_question_id, [
                ...existingQuestions,
                { qId, qText },
              ]);
            } else {
              questionGroupMap.set(parent_question_id, [{ qId, qText }]);
            }
          }
        });
        setQuestionMap(questionGroupMap);
      } catch (err) {
        // (This file has its own state named errorMessage, so the shared helper
        // of that name can't be used here without an alias.)
        toast.error("We couldn't load the follow-up questions. Refresh and try again.");
      }
    };
    //
  
    const handlePageContextChange = (event, newAlignment) => {
        if (newAlignment == null || newAlignment == 'PRESCRIPTION') {
            setPageContext('PRESCRIPTION');
            //setPageContext(newPageContext); // Update your page context
            setRefreshCounter(prevCounter => prevCounter + 1);
            setColumns([
                // {
                //     accessorKey: 'medicineId',
                //     header: 'ID',
                //     enableColumnOrdering: false,
                //     enableEditing: false,
                //     size: 50,
                // },
                {
                    accessorKey: 'presName',
                    header: 'Name',
                    enableColumnOrdering: false,
                    enableEditing: false,
                    size: 50,
                },
                {
                    accessorKey: 'presType',
                    header: 'Prescription Type',
                },
                {
                    accessorKey: 'category',
                    header: 'Category',
                },
                {
                    accessorKey: 'diagnosis',
                    header: 'Diagnosis',
                },
                // {
                //     accessorKey: 'actions',
                //     header: 'Actions',
                // }
            ]);
            setTableData(prescriptionList)
        }
        else if (newAlignment === "QUESTIONNAIRE") {
          setPageContext("QUESTIONNAIRE");
          setRefreshCounter(prevCounter => prevCounter + 1);
          setTableData(Questionnaires);
          hanldeUpdateColumns();
        } 
        else if (newAlignment == 'DIAGNOSIS') {
            setPageContext('DIAGNOSIS');
            setRefreshCounter(prevCounter => prevCounter + 1);
            setColumns([
                // {
                //     accessorKey: 'diagId',
                //     header: 'ID',
                //     enableColumnOrdering: false,
                //     enableEditing: false,
                //     size: 50,
                // },
                {
                    accessorKey: 'name',
                    header: 'Name',
                    enableColumnOrdering: false,
                    enableEditing: false,
                    size: 50,
                },
                // {
                //     accessorKey: 'info',
                //     header: 'Info',
                // }
            ]);


            setTableData(diagnosisData);
        }


        else if (newAlignment == 'CATEGORY') {
            setPageContext('CATEGORY');
            setRefreshCounter(prevCounter => prevCounter + 1);
            setColumns([
                // {
                //     accessorKey: 'categoryID',
                //     header: 'ID',
                //     enableColumnOrdering: false,
                //     enableEditing: false,
                //     size: 50,
                // },
                {
                    accessorKey: 'categoryName',
                    header: 'Category Name',
                    enableColumnOrdering: false,
                    enableEditing: false,
                    size: 50,
                },
            ]);

            setTableData(categoryData);
        }

        else if (newAlignment == 'PRES_TYPE') {
            setPageContext('PRES_TYPE');
            setRefreshCounter(prevCounter => prevCounter + 1);
            setColumns([
                // {
                //     accessorKey: 'presTypeId',
                //     header: 'ID',
                //     enableColumnOrdering: false,
                //     enableEditing: false,
                //     size: 50,
                // },
                {
                    accessorKey: 'presTypeName',
                    header: 'Prescription Type',
                    enableColumnOrdering: false,
                    enableEditing: false,
                    size: 50,
                },
                {
                    id: 'presTypeShowOverview',
                    accessorFn: (row) => row.presTypeShowOverview ? 'True' : 'False', 
                    header: 'Show in Education Tab',
                    enableColumnOrdering: false,
                    enableEditing: false,
                    size: 50,
                },
            ]);


            setTableData(presTypeData);
        }
    };


    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    const navigate = useNavigate();
    useEffect(() => {
        count += 1;
        if (!isRendered.current) {
            fetchPrescitions();
            fetchAllDiagnoses();
            fetchAllQuestionnaireForms();
            fetchCategoryData();
            fetchPresTypeData();
            isRendered.current = true;
        }
        else {
        }
    }, []);

    useEffect(() => {
      if (!refetchQuestionnaire || !selectedQuestion) return;
      fetchAllQuestionnaireForms();
    }, [refetchQuestionnaire, selectedQuestion]);

    // diagId, name, info
    const fetchPrescitions = async () => {
        Cookies.get(COOKIE_KEYS.userType) == 'ADMIN' ? setAuthContext('ADMIN') : (Cookies.get(COOKIE_KEYS.userType) == 'ASSITANT' ? setAuthContext('ASSITANT') : navigate('/login'));
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllPrescriptions`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            canRenderAdmin(true);
            let tempData = [];
            for (let i = 0; i < res.data.length; i++) {
                let temp = {
                    presId: res.data[i].presId,
                    presName: res.data[i].name,
                    presType: res.data[i].presType.name,
                    presTypeId: res.data[i].presType.presTypeId,
                    diagnosis: res.data[i].diagnosis.name,
                    diagnosisId: res.data[i].diagnosis.diagId,
                    shortInfo: res.data[i].shortInfo,
                    overview: res.data[i].overview,
                    category: res.data[i].category ? res.data[i].category.name : '-- ',
                    categoryId: res.data[i].category && res.data[i].category.categoryId,
                };
                tempData.push(temp);
            }
            setPrescription(tempData);
            setTableData(tempData);
            setRenderPrescriptionApiData(true);
        }
        catch (err) {
            setRenderPrescriptionApiData(false);
        }
    };

    const fetchAllDiagnoses = async () => {
        // console.log("====^^^===");
        // console.log("fetchAllDiagnoses START");
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllDiagnoses`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            setDiagnosisData(res.data);
            if (pageContext == 'DIAGNOSIS') {
                setTableData(res.data);
            }
            setRenderPrescriptionApiData(true);
        }
        catch (err) {
            cannotrenderapidata({
                prescriptionRender: true,
                diagnosisRender: false,
                questionnairesRender: true,
            });
            setRenderDiagnosisApiData(false);
        }
        // console.log("fetchAllDiagnoses END");
        // console.log("====^^^===");
    };

    const getOptionsStringFromApiData = (qOptsArray) => {
        let str = "$ ";
        for (let i = 0; i < qOptsArray.length; i++) {
            let temp = qOptsArray[i].oName + " $ ";
            str += temp;
        }
        // console.log('Opts str :: '+ str);
        return str;
    }
    //   getAllQuestionnaires
    const fetchAllQuestionnaires = async () => {
        // console.log("====^^^===");
        // console.log("fetchAllQuestionnaires START");
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllQuestionnaires`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            let tempData = [];
            for (let i = 0; i < res.data.length; i++) {
                let optStr = getOptionsStringFromApiData(res.data[i].options);
                let temp = {
                    questionId: res.data[i].questionId,
                    question: res.data[i].question,
                    options: optStr
                };
                tempData.push(temp);
            }
            setQuestionnaires(tempData);
            if (pageContext == 'QUESTIONNAIRE') {
                setTableData(tempData);
            }

            setRenderQuestionnaireApiData(true);
        }
        catch (err) {

            cannotrenderapidata({
                prescriptionRender: true,
                diagnosisRender: true,
                questionnairesRender: false,
            });
            setRenderQuestionnaireApiData(false);
        }
        // console.log("fetchAllQuestionnaires END");
        // console.log("====^^^===");
    };

    const fetchCategoryData = async () => {
        // Cookies.get(COOKIE_KEYS.userType) == 'ADMIN' ? setAuthContext('ADMIN') : (Cookies.get(COOKIE_KEYS.userType) == 'ASSITANT' ? setAuthContext('ASSITANT') : navigate('/login'));
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllCategories`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            canRenderAdmin(true);
            let tempData = [];
            for (let i = 0; i < res.data.length; i++) {
                let temp = {
                    categoryID: res.data[i].categoryId,
                    categoryName: res.data[i].name,
                };
                tempData.push(temp);
            }
            setCategoryData(tempData);
            if (pageContext == 'CATEGORY') {
                setTableData(tempData);
            }
            setRenderCategoryApiData(true);
        }
        catch (err) {
            setRenderCategoryApiData(false);
        }

        // let temp = [{
        //                 catId: 1,
        //                 catName: "testing",
        //             }];
        //             setCategoryData(temp);
        //             setTableData(temp);
        //             setRenderCategoryApiData(true);
    };

    const fetchPresTypeData = async () => {
        // Cookies.get(COOKIE_KEYS.userType) == 'ADMIN' ? setAuthContext('ADMIN') : (Cookies.get(COOKIE_KEYS.userType) == 'ASSITANT' ? setAuthContext('ASSITANT') : navigate('/login'));
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllPreTypes`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            canRenderAdmin(true);
            let tempData = [];
            for (let i = 0; i < res.data.length; i++) {
                let temp = {
                    presTypeId: res.data[i].presTypeId,
                    presTypeName: res.data[i].name,
                    presTypeShowOverview: res.data[i].showOverview
                };
                tempData.push(temp);
            }
            setPresTypeData(tempData);
            if (pageContext == 'PRES_TYPE') {
                setTableData(tempData);
            }
            setRenderPresTypeApiData(true);
        }
        catch (err) {
            setRenderPresTypeApiData(false);
        }
    };

    const fetchAfterDelete = () => {
        if (needsRefresh) {
            if (pageContext == 'QUESTIONNAIRE') {
                fetchAllQuestionnaireForms();
            }
            if (pageContext == 'PRESCRIPTION') {
                fetchPrescitions();
            }
            else if (pageContext == 'DIAGNOSIS') {
                fetchAllDiagnoses();
            }
            else if (pageContext == 'CATEGORY') {
                fetchCategoryData();
            }
            else if (pageContext == 'PRES_TYPE') {
                fetchPresTypeData();
            }
            setRefreshStatus(false);
        }
    }

    const handleAddDiagnosis = guard((data) => {
        setOpen(false);
        const temp = {
            name: data.diagnosisName,
            info: getEditorinHTML()
        }
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        const request = axios.post(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/addDiagnosis", temp, config).then((res) => {
            toast.success("Diagnosis added.");
            fetchAllDiagnoses();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't add that diagnosis. Check the details and try again."));
        });
      return request;
    });

    const handleAddPrescription = guard((data) => {
        const temp = {
            name: data.presName,
            type: parseInt(data.presType),
            shortInfo: data.shortInfo,
            overview: getEditorinHTML(),
            diagnosisId: data.diagnosis.map(d => parseInt(d)),
            categoryId: parseInt(data.category) || null
        };

        const request = axios.post(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/addPrescription", temp).then((res) => {
            toast.success("Medicine added to the approved list.");
            fetchPrescitions();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't add that medicine. Check the details and try again."));
        });
        setOpen(false);

      return request;
    });

    const handleUpdatePrescription = guard(() => {
        const temp = {
            name: popUpData.presName,
            type: popUpData.presTypeId,
            diagnosisId: popUpData.diagnosisId,
            shortInfo: popUpData.shortInfo,
            categoryId: popUpData.categoryId !== '' ? popUpData.categoryId : null,
            overview: getEditorinHTML()
        };
        const request = axios.put(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/updatePrescription/${popUpData.presId}`, temp).then((res) => {
            toast.success(`Changes to ${popUpData.presName} saved.`);
            fetchPrescitions();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't save changes to that medicine. Check the details and try again."));
        });
        setOpen(false);

      return request;
    });

    const handleUpdateDiagnosis = guard(() => {
        const temp = {
            name: popUpData.name,
            info: getEditorinHTML()
        };
        const request = axios.put(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/updateDiagnosis/${popUpData.diagId}`, temp).then((res) => {
            toast.success(`Changes to ${popUpData.name} saved.`);
            fetchAllDiagnoses();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't save changes to that diagnosis. Check the details and try again."));
        });
        setOpen(false);

      return request;
    });

    const hanldeUpdateColumns = (questionnaire = "") => {
      setColumns([
        {
          accessorKey: "questionnaire_type",
          header: "Questionnaire",
          size: 250,
        },
        {
          accessorKey: "status",
          header: "Status",
          size: 250,
        },
        {
          accessorKey: "diag_name",
          header: "Diagnosis",
          size: 250,
        },
        {
          accessorKey: "questionnaire_stage",
          header: "Stage",
          size: 250,
        },
        // {
        //   accessorKey: "action",
        //   header: "Actions",
        //   size: 100,
        //   Cell: ({ row }) => (),
        // },
      ]);
    };

    const handleAddQuestionnaire = () => {
      setOpen(true);
    };
    const handleAddQuestionnaireNew = guard(() => {
      const newQuestionnaire = inputRef.current.value;
      const checkbox = document.getElementById("ActiveCheck");
      const dropdownValue = document.getElementById("questionnaireStage").value;
  
      const temp = {
        questionnaire_type: newQuestionnaire,
        diag_id: selectedDiagnosis === "" ? null : selectedDiagnosis,
        status: checkbox.checked ? "Active" : "Inactive",
        questionnaire_stage: dropdownValue,
      };
  
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      const request = axios
        .post(
          API_DETAILS.baseUrl +
            API_DETAILS.PORT +
            API_DETAILS.baseExtension +
            "/addQuestionnaireForm",
          temp,
          config
        )
        .then((res) => {
          toast.success("Questionnaire added. Add its questions next.");
          fetchAllQuestionnaireForms();
          setSelectedDiagnosis(null);
        })
        .catch((err) => {
          toast.error(errorMessage(err, "We couldn't add that questionnaire. Check the details and try again."));
        });
  
      setOpen(false);
      return request;
    });
    const handleEditQuestionnaire = guard(() => {

      const dropdownValue = document.getElementById("questionnaireStage").value;
      const temp = {
        id: selectedQuestionnaireId,
        questionnaire_type: selectedQuestionnaire,
        diagnosis_id: selectedDiagnosis,
        status: isChecked ? "Active" : "Inactive",
        questionnaire_stage: dropdownValue,
      };
  
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      const request = axios
        .put(
          API_DETAILS.baseUrl +
            API_DETAILS.PORT +
            API_DETAILS.baseExtension +
            "/updateQuestionnaireInfo",
          temp,
          config
        )
        .then((res) => {

            if (res.data.message === "Update Failed: Same questionnaire stage and diagnosis already exist") {
                toast.error("A questionnaire for that diagnosis and stage already exists. Edit that one, or choose a different stage.");
            } else {
                toast.success("Questionnaire changes saved.");
                fetchAllQuestionnaireForms();
                setSelectedDiagnosis(null);
            }
        })
        .catch((err) => {
          toast.error(errorMessage(err, "We couldn't save changes to that questionnaire. Try again in a moment."));
        });
  
      setOpen(false);
      return request;
    });

    const fetchAllQuestionnaireForms = async () => {
      const url =
        API_DETAILS.baseUrl +
        API_DETAILS.PORT +
        API_DETAILS.baseExtension +
        `/getAllQuestionnaireForms`;
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      try {
        const res = await axios.get(url, config);
        if (res && res.data) {
        }
        if (pageContext === "QUESTIONNAIRE" || refetchQuestionnaire) {
          setTableData(res.data);
        }
        setQuestionnairesUpdate(res.data);
        setRenderPrescriptionApiData(true);
      } catch (err) {
        cannotrenderapidata({
          prescriptionRender: true,
          diagnosisRender: true,
          questionnairesRender: false,
        });
        setRenderDiagnosisApiData(false);
      }
    };

    const handleAddQuestion = () => {
      const options = [
        "Mild/Severe/None",
        "Yes/No",
        "Yes/No/Skip",
        "Yes/No/Unsure",
        "1/2/3/4/5",
        "1/2/3/4/5/6/7/8/9/10",
      ];
      setOptions(options);
      setIsAddQuestionClicked(true);
      setOpenInnerPopUp(true);
    };
  
    const handleAddFollowUpQuestion = (pId, oId) => {
      const options = [
        "Mild/Severe/None",
        "Yes/No",
        "Yes/No/Skip",
        "Yes/No/Unsure",
        "1/2/3/4/5",
        "1/2/3/4/5/6/7/8/9/10",
      ];
      setOptions(options);
      setIsAddQuestionClicked(true);
      setOpenInnerPopUp(true);
      setIsFollowUp(true);
      setParentId(pId);
      setOptionId(oId);
    };
    
    const handleAddQuestionInner = guard(async () => {
        let request;
        const newQuestion = inputRef.current.value;
      if (newQuestion.trim() !== "" && questionWeight !== null) {
        if (questionWeight <= 0 || questionWeight > 10) {
            setErrorMessage("Enter Question Weight Between 1 to 10 (Both Inclusive)")
        } else if (customOptions.length < 2) {
            setErrorMessage("Enter at least 2 options and its weights");
        } else {
            const temp = {
              question: newQuestion,
              weight: questionWeight,
              questionnaire_id: selectedQuestionnaireId,
              parent_question_id: parentId,
              bound_option_id: optionId,
              optionsList: optionsList.length === 0 ? customOptions : optionsList,
              customOptionWeights: optionsList.length === 0 ? customOptionWeights : customOptionWeights,
            };
            const config = {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*",
                "Content-Type": "application/json",
              },
            };
            request = axios
                    .post(
                        API_DETAILS.baseUrl +
                        API_DETAILS.PORT +
                        API_DETAILS.baseExtension +
                        "/addQuestion",
                temp,
                config
              )
              .then((res) => {
                toast.success("Question added.");

                setCustomOptions([]);
                setCustomOptionWeights([]);
                setQuestions([...questions, newQuestion]);
                handleQuestionnaireSelection(
                  selectedQuestionnaireId,
                  selectedQuestionnaire
                );
                handleEditQuestion(parentId, newQuestion, questionWeight);
                //inputRef.current.value = "";
                setSelectedOption("");
              })
              .catch((err) => {
                toast.error(errorMessage(err, "We couldn't add that question. Check the details and try again."));
              });
            setQuestionWeight(null);
            setOptionWeight(null);
            setOpenInnerPopUp(false);
            setErrorMessage("");
        }
      } else if (newQuestion.trim() !== "") {
        setErrorMessage("Question Weight Missing!");
      } else {
        setQuestionWeight(null);
        setOptionWeight(null);
        setOpenInnerPopUp(false);
        setErrorMessage("");
      }
      return request;
    });

    const handleEditQuestion = async (qid, ques, weight) => {
      const url =
        API_DETAILS.baseUrl +
        API_DETAILS.PORT +
        API_DETAILS.baseExtension +
        `/getQuestionOptions/${qid}`;
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      try {
        const res = await axios.get(url, config);
  
        if (Array.isArray(res.data)) {
          const updatedFollowUpQuestionsMap = new Map();
  
          res.data.forEach((item) => {
            if (item.hasFollowUpQuestion) {
              const childQuestions = item.childQuestions || [];
  
              if (!updatedFollowUpQuestionsMap.has(item.oId)) {
                updatedFollowUpQuestionsMap.set(item.oId, []);
              }
  
              const followUpQues = updatedFollowUpQuestionsMap.get(item.oId);
              followUpQues.push(...childQuestions);
            }
          });
          setFollowUpQuestions(updatedFollowUpQuestionsMap);
          setQuestionOptions(res.data);
          setSelectedQuestion(ques);
          setQuestionId(qid);
          setIsEditQuestionClicked(true);
          setIsFollowUp(true);
          setQuestionWeight(weight);
        }
      } catch (err) {
      }
    };

    const updateQuestionInfo = guard((qWeight) => {
      const temp = {
        q_id: questionId,
        question: selectedQuestion,
        questionWeight: qWeight,
        questionOptions: questionOptions,
        questionnaire_id: selectedQuestionnaireId,
      };

      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };

      const request = axios
        .put(
          API_DETAILS.baseUrl +
            API_DETAILS.PORT +
            API_DETAILS.baseExtension +
            "/updateQuestionInfo",
          temp,
          config
        )
        .then((res) => {
          toast.success("Question changes saved.");
        })
        .catch((err) => {
          toast.error(errorMessage(err, "We couldn't save changes to that question. Try again in a moment."));
        });

      setOpen(false);
      setIsEditQuestionClicked(false);
      setErrorMessage("");
      setQuestionWeight(null);
      setOptionWeight(null);
      return request;
    });

    const handleSaveEditQuestion = () => {
      const qWeight = questionWeight ? questionWeight : "";
      const isCommonForm = (selectedQuestionnaire == "General Form" || selectedQuestionnaire == "Intake Form");
      if (selectedQuestion.trim() !== "" && qWeight !== "" || selectedQuestion.trim() !== "" && isCommonForm) {
        const isOptionWeightsNotValid = questionOptions.some(option => option.weight > questionWeight);
        if (isCommonForm) {
          updateQuestionInfo(qWeight);
        } else if (qWeight <= 0 || qWeight > 10) {
          setErrorMessage("Enter Question Weight Between 1 to 10 (Both Inclusive)")
        } else if (questionOptions.length < 2) {
          setErrorMessage("Enter at least 2 options and its weights");
        } else if (isOptionWeightsNotValid) {
          setErrorMessage("Options' weight cannot exceed question's weight");
        }
        else {
          updateQuestionInfo(qWeight);
        }
      } else if (selectedQuestion.trim() !== "") {
        setErrorMessage("Question Weight cannot be empty!");
      } else {
        setErrorMessage("Question cannot be empty!");
      }
    };

    var parentQuestionCounter = 1;
    const handleActiveChange = () => {
      if (isChecked) {
        setIsChecked(false);
      } else {
        const isPresent = Questionnaires.some(
          (questionnaire) =>
            questionnaire.questionnaire_type === inputRef.current.value.trim() &&
            questionnaire.status === "Active" &&
            questionnaire.id !== selectedQuestionnaireId
        );
        if (isPresent) {
          setErrorMessage(
            "Questionnaire form with the same name is already present. Please change the name and try again."
          );
        } else {
          setErrorMessage("");
        }
        setIsChecked(!isPresent);
      }
    };

    const handleDropdownChange = (e) => {
      setDropdownValue(e.target.value);
    };
  
    const handleInputChange = (event) => {
      setSelectedQuestionnaire(event.target.value);
    };
    const handleQuestionChange = (event) => {
      setSelectedQuestion(event.target.value);
    };
    const handleQuestionWeightChange = (e) => {
        const value = e.target.value;
        const weight = parseInt(value, 10);

        if (value === "") {
          setQuestionWeight(null);
          setErrorMessage("");
        } else if (weight <= 0 || weight > 10) {
          setErrorMessage("Question Weight should be between 1 to 10 (Both Inclusive)");
        } else {
          setQuestionWeight(weight);
          setErrorMessage("");
        }
    }
    const handleAddOptionWeight = (e) => {
      const value = e.target.value;
      const weight = parseInt(value, 10);

      if (questionWeight === null) {
        setErrorMessage("Enter Question's weight first");
      } else if (value === "") {
        setOptionWeight(null);
        setErrorMessage("");
      } else if (weight < 0) {
        setErrorMessage("Option Weight can't be less than zero");
      } else if (weight > questionWeight) {
        setErrorMessage("Option Weight can't be greater than Question's weight");
      } else {
        setOptionWeight(weight);
        setErrorMessage("");
      }
    }
    const handleOptionNameChange = (event, oId) => {
      const updatedOptions = questionOptions.map((option) =>
        option.oId === oId
          ? { ...option, optionName: event.target.value }
          : option
      );
      setQuestionOptions(updatedOptions);
    };
    const handleOptionWeightChange = (e, thisOption) => {
      const value = e.target.value;
      const weight = parseInt(value, 10);

      if (questionWeight === null) {
        setErrorMessage("Enter Question's weight first");
      } else if (value === "") {
        // A new object, not an edit to the one in state: writing to thisOption
        // changed the old array behind React's back and was lost on the next
        // update.
        setQuestionOptions(questionOptions.map((option) =>
          option.oId === thisOption.oId ? { ...option, weight: null } : option
        ));
        setErrorMessage("Options' weight for one or more options is missing");
      } else if (weight < 0) {
        setErrorMessage("Option Weight should be greater than or equal to zero");
      } else if (weight > questionWeight) {
        setErrorMessage("Option Weight should be less than or equal to Question's weight");
      } else {
        // The parsed number, not the text typed: state held the string ("7")
        // while the number was written onto the discarded old object, so the
        // checks above compared text. The server stores an int either way.
        const updatedOptions = questionOptions.map((option) =>
          option.oId === thisOption.oId
            ? { ...option, weight }
            : option
        );
        setErrorMessage("");
        setQuestionOptions(updatedOptions);
      }
    };

  
    const onClickViewInfo = (rowData) => {
        setPopUpData(rowData);        
        const info = pageContext === 'PRESCRIPTION' ? rowData.overview : rowData.info;
        setEditorFromHTML(info || '')
        setPopupMode(POPUPMODES.VIEW)
        setAddPopUpContext(pageContext);
        setOpen(true);
    }

    const onClickEditInfo = (rowData) => {
        setPopUpData(rowData);        
        const info = pageContext === 'PRESCRIPTION' ? rowData.overview : rowData.info;
        
        setEditorFromHTML(info || '')
        setPopupMode(POPUPMODES.EDIT)
        setAddPopUpContext(pageContext);
        setOpen(true);
    }

    const setEditInfo = (key, val) => {
        setPopUpData({
            ...popUpData,
            [key]: val
        })
    }

    const clearEditor = () => {
        setEditorState(EditorState.createEmpty())
    }

    const setEditorFromHTML = (content) => {
        const blocksFromHtml = htmlToDraft(content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
    }

    const getEditorinHTML = () => {
        return draftToHtml(convertToRaw(editorState.getCurrentContent()))
    }

    const onClickAddPrescription = () => {
        reset();
        clearEditor();
        setOpen(true);
        setPopupMode(POPUPMODES.NEW)
        setAddPopUpContext('PRESCRIPTION');
        fetchAllDiagnoses();
    }

    const onClickAddDiagnosis = () => {
        reset();
        clearEditor();
        setOpen(true);
        setPopupMode(POPUPMODES.NEW)
        setAddPopUpContext('DIAGNOSIS');
    }
    const onClickAddCategory = () => {
        reset();
        clearEditor();
        setOpen(true);
        setPopupMode(POPUPMODES.NEW)
        setAddPopUpContext('CATEGORY');
    }
    const onClickAddPresType = () => {
        reset();
        clearEditor();
        setOpen(true);
        setPopupMode(POPUPMODES.NEW)
        setAddPopUpContext('PRES_TYPE');
    }

    const onClickAddSavePrescription = () => {
        if (popUpMode == POPUPMODES.NEW) {
            handleSubmit(handleAddPrescription)();
        }
        if (popUpMode == POPUPMODES.EDIT) {
            handleUpdatePrescription();
        }
    }

    const onClickAddSaveDiagnosis = () => {
        if (popUpMode == POPUPMODES.NEW) {
            handleSubmit(handleAddDiagnosis)();
        }
        if (popUpMode == POPUPMODES.EDIT) {
            handleUpdateDiagnosis();
        }
    }
    const handleAddCategory = guard((data) => {
        //debugger;
        const temp = {
            name: data.categoryName,
        };

        const request = axios.post(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/addCategory", temp).then((res) => {
            toast.success("Category added.");
            fetchCategoryData();
            //reset();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't add that category. Check the name and try again."));
        });
        setOpen(false);
      return request;
    });

    const handleEditCategorySubmit = guard(async () => {
        try {
            const response = await axios.put(`${API_DETAILS.baseUrl}${API_DETAILS.PORT}${API_DETAILS.baseExtension}/editCategory/${editCategoryData.categoryID}`, {
                name: editCategoryData.categoryName,
            });
            toast.success("Category updated.");
            fetchCategoryData(); // Refresh the category list
            setOpen(false); // Close the popup
        } catch (error) {
            toast.error(errorMessage(error, "We couldn't update that category. Check the name and try again."));
        }
    });

    const handleAddPresType = guard((data) => {
        //debugger;
        const temp = {
            name: data.presTypeName,
            showOverview: data.presTypeShowOverview || false
        };

        const request = axios.post(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/addPresType", temp).then((res) => {
            toast.success("Prescription type added.");
            fetchPresTypeData();
            //reset();
        }).catch((err) => {
            toast.error(errorMessage(err, "We couldn't add that prescription type. Check the name and try again."));
        });
        setOpen(false);
      return request;
    });

    const handleEditPresTypeSubmit = guard(async () => {
        try {
            const response = await axios.put(`${API_DETAILS.baseUrl}${API_DETAILS.PORT}${API_DETAILS.baseExtension}/editPresType/${editPresTypeData.presTypeId}`, {
                name: editPresTypeData.presTypeName,
                showOverview: editPresTypeData.presTypeShowOverview
            });
            toast.success("Prescription type updated.");
            fetchPresTypeData(); // Refresh the category list
            setOpen(false); // Close the popup
        } catch (error) {
            toast.error(errorMessage(error, "We couldn't update that prescription type. Check the name and try again."));
        }
    });

    return (
        <div>
            {

                <div className='hm'>
                    <div className='sidebar'>
                        <AdminSideBar data={'manage-approved-medicine'} />
                    </div>
                    <div className="admin-ui-table">
                        <div className='header' style={{ marginLeft: '15px' }}>
                            <Youroheader />
                        </div>
                        <div className='row' style={{ display: 'flex', justifyContent: 'center' }}>
                            {pageContext == 'PRESCRIPTION' &&
                                // <Box sx={{ display: 'flex', gap: '1rem', marginLeft: '15px' }}>
                                //     <Tooltip arrow placement="left" title="Add Prescription">
                                //         <IconButton color="gray" onClick={onClickAddPrescription} className='add-icon' size="large">
                                //             <AddIcon fontSize='inherit' />
                                //         </IconButton>
                                //     </Tooltip>
                                // </Box>
                                <button type="button" className='btn-filled' style={{ marginLeft: '15px' }} onClick={onClickAddPrescription}>Add Prescription</button>
                            }
                            {pageContext == 'DIAGNOSIS' &&
                                // <Box sx={{ display: 'flex', gap: '1rem', marginLeft: '15px' }}>
                                //     <Tooltip arrow placement="left" title="Add Diagnosis">
                                //         <IconButton color="gray" onClick={onClickAddDiagnosis} className='add-icon' size="large">
                                //             <AddIcon fontSize='inherit' />
                                //         </IconButton>
                                //     </Tooltip>
                                // </Box>
                                <button type="button" className='btn-filled' style={{ marginLeft: '15px' }} onClick={onClickAddDiagnosis}>Add Diagnosis</button>
                            }
                            {/* {pageContext == 'QUESTIONNAIRE' && <div className='btn-filled' style={{ width: 'fit-content', marginLeft: '15px' }} onClick={() => { setOpen(true); setAddPopUpContext('QUESTIONNAIRE'); fetchAllDiagnoses(); }}> Add Questionnaire</div>} */}
                            {
                                pageContext == 'CATEGORY' &&
                                // <Box sx={{ display: 'flex', gap: '1rem', marginLeft: '15px' }}>
                                //     <Tooltip arrow placement="left" title="Add Category">
                                //         <IconButton color="gray" onClick={onClickAddCategory} className='add-icon' size="large">
                                //             <AddIcon fontSize='inherit' />
                                //         </IconButton>
                                //     </Tooltip>
                                // </Box>
                                <button type="button" className='btn-filled' style={{ marginLeft: '15px' }} onClick={onClickAddCategory}>Add Category</button>
                            }

                            {
                                pageContext == 'PRES_TYPE' &&
                                // <Box sx={{ display: 'flex', gap: '1rem', marginLeft: '15px' }}>
                                //     <Tooltip arrow placement="left" title="Add Prescription Type">
                                //         <IconButton color="gray" onClick={onClickAddPresType} className='add-icon' size="large">
                                //             <AddIcon fontSize='inherit' />
                                //         </IconButton>
                                //     </Tooltip>
                                // </Box>
                                <button type="button" className='btn-filled' style={{ marginLeft: '15px'}} onClick={onClickAddPresType}>Add Prescription Type</button>
                            }
                            {pageContext === "QUESTIONNAIRE" && (
                                <div className='btn-filled' style={{ marginLeft: '15px'}} onClick={() => {
                                  setOpen(true);
                                  setAddPopUpContext("QUESTIONNAIRE");
                                  handleAddQuestionnaire();
                                }}>Add Questionnaire</div>
                              )}
                            <ToggleButtonGroup
                                value={pageContext}
                                exclusive
                                onChange={handlePageContextChange}
                                aria-label="Platform"
                            >
                                <ToggleButton value="PRESCRIPTION">Prescription</ToggleButton>
                                <ToggleButton value="DIAGNOSIS">Diagnosis</ToggleButton>
                                <ToggleButton value="QUESTIONNAIRE">Questionnaire</ToggleButton>
                                <ToggleButton value="CATEGORY">Category</ToggleButton>
                                <ToggleButton value="PRES_TYPE">Prescription Type</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        {
                            renderAdmin == true && tableData && tableData.length > 0 ?
                                (
                                    <MaterialReactTable
                                        //options={{ actionsColumnIndex: -1 }}
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                muiTableHeadCellProps: {
                                                    align: 'center',
                                                },
                                                size: 120,
                                            },
                                        }}
                                        key={refreshCounter} // Use the refreshCounter as a key to force re-render
                                        columns={columns}
                                        data={tableData}
                                        enableStickyHeader
                                        enableColumnOrdering
                                        enableRowActions={authContext == 'ADMIN'}
                                        enableEditing={authContext == 'ADMIN'}
                                        muiTableContainerProps={{ sx: { maxHeight: window.innerHeight } }}
                                        positionGlobalFilter="left"
                                        initialState={{
                                            showGlobalFilter: true,
                                        }}
                                        muiSearchTextFieldProps={{
                                          placeholder: `Search`,
                                          sx: { minWidth: '300px'},
                                          variant: 'outlined',
                                          size: 'small'
                                        }}
                                        positionActionsColumn='last'
                                        renderRowActions={({ row }) => (
                                            authContext == 'ADMIN' && (
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                    {pageContext !== 'QUESTIONNAIRE' && (
                                                      <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                        <Tooltip arrow placement="top" title="Delete">
                                                            <AdminPopUps
                                                                data={{
                                                                    'action': `delete-${pageContext.toLowerCase()}`,
                                                                    'step': 1,
                                                                    'rowData': row.original,
                                                                    // Passed as a reference. It used to be called here, which meant every row
                                                                    // re-ran a fetch-and-setState during render.
                                                                    'postDeleteAction': fetchAfterDelete,
                                                                    'setParentRefreshStatus': setRefreshStatus
                                                                }} />
                                                        </Tooltip>
                                                    </Box>
                                                    )}
                                                    {pageContext === 'QUESTIONNAIRE' && (
                                                      <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-start",
                                                        gap: "1rem",
                                                      }}
                                                    >
                                                      <button
                                                        key={`edit-${row.original.questionnaire_type}`}
                                                        aria-label="Edit"
                                                        onClick={() => {
                                                          setOpen(true);
                                                          setAddPopUpContext("QUESTIONNAIRE");
                                                          setSelectedQuestionnaire(row.original.questionnaire_type);
                                                          setSelectedDiagnosis(row.original.diag_id);
                                                          setIsEditQuestionnaireClicked(true);
                                                          setSelectedQuestionnaireId(row.original.id);
                                                          row.original.status === "Active"
                                                            ? setIsChecked(true)
                                                            : setIsChecked(false);
                                                        }}
                                                        style={{
                                                          border: "none",
                                                          background: "transparent",
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <EditIcon />
                                                      </button>
                                                      <button
                                                        key={`add-${row.original.questionnaire_type}`}
                                                        aria-label="Edit"
                                                        onClick={() =>
                                                          handleQuestionnaireSelection(
                                                            row.original.id,
                                                            row.original.questionnaire_type
                                                          )
                                                        }
                                                        style={{
                                                          border: "none",
                                                          background: "transparent",
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <AddIcon />
                                                      </button>
                                                      <Tooltip arrow placement="right" title="Delete">
                                                        <AdminPopUps
                                                          data={{
                                                            action: `delete-questionnaire`,
                                                            step: 1,
                                                            rowData: { id: row.original.id },
                                                            postDeleteAction: () => {
                                                              // handleSetPageContext();
                                                              // // setPageContext("QUESTIONNAIRE");
                                                              // // setRefetchQuestionnaire(true);
                                                              fetchAllQuestionnaireForms();
                                                              setShowAdminPopUps(false);
                                                            },
                                                            setParentRefreshStatus: (status) => {
                                                              setRefreshStatus(status);
                                                              setShowAdminPopUps(false);
                                                            },
                                                            setPageContextAgain: (context) => {
                                                              setPageContext(context);
                                                              setShowAdminPopUps(false);
                                                            },
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    </Box>                                        
                                                    )}
                                                    {(pageContext === 'PRESCRIPTION' || pageContext === 'DIAGNOSIS') && (
                                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                            <Tooltip arrow placement="top" title="Edit Info">
                                                                <IconButton
                                                                    color="gray"
                                                                    onClick={() => onClickEditInfo(row.original)}
                                                                    className='delete-doctor-button'
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    )}
                                                    {(pageContext === 'PRESCRIPTION' || pageContext === 'DIAGNOSIS') && (
                                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                            <Tooltip arrow placement="top" title="View Info">
                                                                <button type="button" className='view-info-button' onClick={() => onClickViewInfo(row.original)}>View Info</button>
                                                            </Tooltip>
                                                        </Box>
                                                    )}
                                                    {pageContext === 'CATEGORY' && (
                                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                            <Tooltip arrow placement="right" title="Edit">
                                                                <IconButton
                                                                    onClick={() => { setOpen(true); setAddPopUpContext('EDIT_CATEGORY'); setEditCategoryData(row.original); }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    )}
                                                    {pageContext === 'PRES_TYPE' && (
                                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                                            <Tooltip arrow placement="right" title="Edit">
                                                                <IconButton
                                                                    onClick={() => { setOpen(true); setAddPopUpContext('EDIT_PRES_TYPE'); setEditPresTypeData(row.original); }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    )}
                                                </div>
                                            )
                                        )}

                                        muiTableBodyProps={{
                                            sx: () => ({
                                                '& tr:nth-of-type(odd)': {
                                                    backgroundColor: "lightgray",
                                                },
                                            }),
                                        }}
                                    />
                                )
                                : (
                                    ((pageContext == 'PRESCRIPTION' && !renderPrescriptionApiData) || (pageContext == 'DIAGNOSIS' && !renderDiagnosisApiData) || (pageContext == 'QUESTIONNAIRE' && !renderQuestionnaireApiData) || (pageContext == 'CATEGORY' && !renderCategoryApiData) || (pageContext == 'PRES_TYPE' && !renderPresTypeApiData)) ?
                                        (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh', }}>
                                            We couldn't load this list. Refresh to try again.
                                        </div>)
                                        : !renderAdmin ?
                                            (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh' }} ><Oval /></div>)
                                            : renderAdmin == true && tableData && tableData.length == 0 &&
                                            <>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh', }}>
                                                    Nothing here yet.
                                                </div>
                                            </>
                                )
                        }
                    </div>
                </div>


            }
            <Popup 
              open={open}
              modal
              closeOnDocumentClick={false}
              onClose={() => {
                setOpen(false);
                setIsChecked(false);
                setSelectedQuestionnaire(null);
                setIsEditQuestionnaireClicked(false);
                setIsChecked(false);
                setSelectedQuestionnaireId(null);
                setErrorMessage(null);
                setSelectedDiagnosis(null);
                }} 
              className="order-popup"
              contentStyle={{overflowY: 'auto', height: '90%'}}
            >
                <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }} {...clickable(() => { setOpen(false) }, 'Close')}>
                    <span className="material-symbols-outlined">
                        close
                    </span>
                </div>
                {addPopUpContext == 'PRESCRIPTION' && <>
                    <div style={{ padding: '25px', marginBottom: '25px' }}>
                        <div className="" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                            {(popUpMode == POPUPMODES.NEW || popUpMode == POPUPMODES.EDIT) && (<>
                                <label>Name<span style={{ color: 'red', fontSize: '1.2em'}}>*</span>:</label>
                                {popUpMode == POPUPMODES.NEW ? (
                                    <>
                                        <input className="input-field-doctor input-border" type="text" style={{ width: '60%', marginLeft: '20px' }} {...register("presName", {
                                            required: true,
                                            maxLength: 64,
                                        })} />
                                        {errors?.presName?.type === "required" && <p className="error-text">This field is required</p>}
                                        {errors?.presName?.type === "maxLength" && <p className="error-text"> Name cannot exceed 64 characters</p>}
                                    </>
                                ) : (
                                    <>
                                        <input
                                            className="input-field-doctor input-border"
                                            type="text"
                                            style={{ width: '60%', marginLeft: '20px' }}
                                            value={popUpData.presName || ''}
                                            onChange={e => setEditInfo('presName', e.target.value)}
                                        />
                                    </>
                                )}
                            </>)}
                            {(popUpMode == POPUPMODES.VIEW) && (<>
                                <h2>{popUpData.presName}</h2>
                            </>)}
                        </div>
                        <br />
                        <div className="">
                            <label>Prescription Type<span style={{ color: 'red', fontSize: '1.2em'}}>*</span>:</label><br />
                            {popUpMode == POPUPMODES.NEW && (<>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <select
                                    style={{ width: '25vw' }}
                                    className="input-field input-border"
                                    id="gender"
                                    {...register("presType", { required: true, })}
                                >
                                    <option value="">Select</option>
                                    {presTypeData.map((presType, index) => (
                                        <option key={index} value={presType.presTypeId}>
                                            {presType.presTypeName}
                                        </option>
                                    ))}
                                </select>
                                {errors?.presType && <p className="error-text">This field is required</p>}
                            </div>
                            </>)}
                            {(popUpMode === POPUPMODES.VIEW || popUpMode === POPUPMODES.EDIT) && (<>
                                <select
                                    style={{ width: '25vw' }}
                                    className="input-field input-border"
                                    id="gender"
                                    disabled={popUpMode === POPUPMODES.VIEW}
                                    value={popUpData.presTypeId}
                                    onChange={e => setEditInfo('presTypeId', parseInt(e.target.value))}

                                >
                                    {presTypeData.map(presType => (
                                        <option key={presType.presTypeId} value={presType.presTypeId}>
                                            {presType.presTypeName}
                                        </option>
                                    ))}
                                </select>
                            </>)}
                        </div>
                        <br />
                        <div className="">
                            <label>Category :</label><br />
                            {popUpMode == POPUPMODES.NEW && (
                                <>
                                    <select style={{ width: '25vw' }} className="input-field input-border" id="gender" disabled={popUpMode != POPUPMODES.NEW} {...register("category", {
                                        required: false,
                                    })}>
                                        <option>Select</option>
                                        {categoryData.map((categoryData, index) => (
                                            <option key={index} value={categoryData.categoryID}>
                                                {categoryData.categoryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.category && <p className="error-text">This field is required</p>}
                                </>
                            )}
                            {(popUpMode === POPUPMODES.VIEW || popUpMode === POPUPMODES.EDIT) && (<>
                                <select
                                    style={{ width: '25vw' }}
                                    className="input-field input-border"
                                    id="gender"
                                    disabled={popUpMode === POPUPMODES.VIEW}
                                    value={popUpData.categoryId || ''}
                                    onChange={e => setEditInfo('categoryId', parseInt(e.target.value))}
                                >
                                    <option value="">Select</option>
                                    {categoryData.map((categoryData, index) => (
                                        <option key={index} value={categoryData.categoryID}>
                                            {categoryData.categoryName}
                                        </option>
                                    ))}
                                </select>
                            </>)}
                        </div> <br ></br>
                        <div className="">
                            {popUpMode == POPUPMODES.NEW && (
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label>Diagnosis<span style={{ color: 'red', fontSize: '1.2em'}}>*</span>:</label><br />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
                                        {
                                            diagnosisData.map((diagosis) => {
                                                return (
                                                        <div key={diagosis.diagId} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: '20px' }}>
                                                            <input type="checkbox" id={`diagnosis-${diagosis.diagId}`} name="diagnosis" value={diagosis.diagId} {...register("diagnosis", {
                                                                required: true,
                                                            })} />
                                                            <label htmlFor={`diagnosis-${diagosis.diagId}`} style={{ marginLeft: '10px' }}>{diagosis.name}</label><br /><br />
                                                        </div>
                                                )
                                            })
                                        }
                                        {errors?.diagnosis && <p className="error-text">This field is required</p>}
                                    </div>
                                </div>
                            )}
                            {(popUpMode == POPUPMODES.VIEW || popUpMode == POPUPMODES.EDIT) && (<>
                                <div className=''>
                                    <label>Diagnosis<span style={{ color: 'red', fontSize: '1.2em'}}>*</span>:</label> <br />
                                    <select
                                        style={{ width: '25vw' }}
                                        className="input-field input-border"
                                        id="gender"
                                        disabled={popUpMode === POPUPMODES.VIEW}
                                        value={popUpData.diagnosisId}
                                        onChange={e => setEditInfo('diagnosisId', parseInt(e.target.value))}

                                    >
                                        {diagnosisData.map(diagnosis => (
                                            <option value={diagnosis.diagId}>{diagnosis.name}</option>
                                        ))}
                                    </select>
                                </div><br />
                            </>)}

                        </div>
                        <br />
                        <div className="" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label>Brief Overview<span style={{ color: 'red', fontSize: '1.2em'}}>*</span>:</label>
                            {popUpMode == POPUPMODES.NEW && (<>
                                <input
                                    className="input-field-doctor input-border"
                                    type="text"
                                    style={{ width: '98%' }}
                                    {...register("shortInfo",
                                        {
                                            required: true,
                                            maxLength: 128,
                                        })
                                    }
                                />
                                {errors?.shortInfo?.type === "maxLength" && <p className="error-text"> Brief Overview cannot exceed 128 characters</p>}
                                {errors?.shortInfo?.type === "required" && <p className="error-text">This field is required</p>}
                            </>)}
                            {(popUpMode == POPUPMODES.VIEW) && (<>
                                <input
                                    className="input-field-doctor input-border"
                                    type="text"
                                    style={{ width: '98%' }}
                                    value={popUpData.shortInfo || ''}
                                    disabled
                                />
                            </>)}
                            {(popUpMode == POPUPMODES.EDIT) && (<>
                                <input
                                    className="input-field-doctor input-border"
                                    type="text"
                                    style={{ width: '98%' }}
                                    value={popUpData.shortInfo || ''}
                                    onChange={e => setEditInfo('shortInfo', e.target.value)}
                                />
                            </>)}
                        </div>
                        <br />
                        <div className="">
                            <label>Detailed Overview :</label><br />
                            <CustomToolbarEditor
                                readOnly={popUpMode === POPUPMODES.VIEW}
                                editorState={editorState}
                                setEditorState={setEditorState}
                            />
                        </div>
                    </div>
                    {(popUpMode == POPUPMODES.NEW || popUpMode == POPUPMODES.EDIT) && (
                        <>
                            <div
                                className='btn-filled'
                                style={{ width: 'fit-content', margin: '0px auto 25px auto' }}
                                onClick={onClickAddSavePrescription}
                            >
                                {popUpMode == POPUPMODES.NEW ? "Add Prescription" : "Save Changes"}
                            </div>
                        </>
                    )}
                </>}
                {addPopUpContext == 'DIAGNOSIS' && <>
                <div style={{ padding: '25px', width: '65vw', marginBottom: '25px' }}>
                    <div className="" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '20px'}}>
                    {(popUpMode == POPUPMODES.NEW || popUpMode == POPUPMODES.EDIT) ? (
                        <>                    
                            <label>Diagnosis Name<span style={{ color: 'red', fontSize: '1.5em', padding: '0.2em' }}>*</span>:</label>
                            {popUpMode == POPUPMODES.NEW ? (
                                <>
                                    <input className="input-field-doctor input-border" type="text" style={{ width: '94%' }} {...register("diagnosisName", {
                                        required: true,
                                        maxLength: 50,
                                    })} />
                                    {errors?.diagnosisName?.type === "required" && <p className="error-text">This field is required</p>}
                                    {errors?.diagnosisName?.type === "maxLength" && <p className="error-text">Diagnosis Name cannot exceed 50 characters</p>}
                                </>
                            ): (
                                <input
                                className="input-field-doctor input-border"
                                type="text"
                                style={{ width: '94%' }}
                                value={popUpData.name}
                                onChange={e => setEditInfo('name', e.target.value)}
                                /> 
                            )}
                        </>) : (
                            <h2>{popUpData.name}</h2>
                        )}

                    </div>

                    <div className="">
                        <label>Diagnosis Info :</label>
                        <CustomToolbarEditor
                            readOnly={popUpMode === POPUPMODES.VIEW}
                            editorState={editorState}
                            setEditorState={setEditorState}
                        />
                    </div>


                    </div>
                    {(popUpMode == POPUPMODES.NEW || popUpMode == POPUPMODES.EDIT) && (
                        <>
                            <div
                                className='btn-filled'
                                style={{ width: 'fit-content', margin: '0px auto 25px auto' }}
                                onClick={onClickAddSaveDiagnosis}
                            >
                                {popUpMode == POPUPMODES.NEW ? "Add Diagnosis" : "Save Changes"}
                            </div>
                        </>
                    )}
                </>}
                {addPopUpContext == 'CATEGORY' && <>
                    <div style={{ padding: '50px 20px', maxWidth: '60vw', minWidth: '30vw' }}>
                        <div style={{ width: '300px' }}>

                        </div>
                        <div className="" style={{ display: 'flex', marginBottom: '1.5vh' }}>
                            <label>Category Name<span style={{ color: 'red', fontSize: '1.5em', padding: '0.2em' }}>*</span>:</label>
                            <input className="input-field-doctor input-border" type="text" style={{ width: '94%' }} {...register("categoryName", {
                                required: true,
                                maxLength: 50,
                            })} />
                            {errors?.categoryName?.type === "required" && <p className="error-text">This field is required</p>}
                            {errors?.categoryName?.type === "maxLength" && <p className="error-text">category Name cannot exceed 50 characters</p>}
                        </div><br />
                    </div>

                    <div>
                        <button type="button" className='btn-filled' style={{ width: 'fit-content', margin: '0px auto 50px auto' }} onClick={handleSubmit(handleAddCategory)}>Add category</button>
                    </div>
                </>}


                {addPopUpContext === 'EDIT_CATEGORY' && (
                    <div style={{ padding: '50px 20px', maxWidth: '60vw', minWidth: '30vw' }}>
                        <div style={{ width: '300px' }}>
                        </div>
                        <div className="" style={{ display: 'flex', marginBottom: '1.5vh' }}>
                            <label>Category Name :</label>
                            <input
                                className="input-field-doctor input-border"
                                type="text"
                                style={{ width: '94%' }}
                                defaultValue={editCategoryData.categoryName}
                                onChange={(e) => setEditCategoryData({ ...editCategoryData, categoryName: e.target.value })}
                                required={true}
                                maxLength={50}

                            />
                            {errors?.categoryName?.type === "required" && <p className="error-text">This field is required</p>}
                            {errors?.categoryName?.type === "maxLength" && <p className="error-text">Category Name cannot exceed 50 characters</p>}

                        </div>
                        <br />
                        <div>

                            <div
                                className='btn-filled'
                                style={{ width: 'fit-content', margin: '0px auto 50px auto' }}
                                onClick={() => handleEditCategorySubmit()}
                            >
                                Save Changes
                            </div>
                        </div>
                    </div>
                )}

                {addPopUpContext == 'PRES_TYPE' && <>
                    <div style={{ padding: '50px 20px', maxWidth: '60vw', minWidth: '30vw' }}>
                        <div style={{ width: '300px' }}>

                        </div>
                        <div className="" style={{ display: 'flex', marginBottom: '1.5vh' }}>
                            <label>Prescription Type Name<span style={{ color: 'red', fontSize: '1.5em', padding: '0.2em' }}>*</span>:</label>
                            <input className="input-field-doctor input-border" type="text" style={{ width: '94%' }} {...register("presTypeName", {
                                required: true,
                                maxLength: 50,
                            })} />
                            {errors?.presTypeName?.type === "required" && <p className="error-text">This field is required</p>}
                            {errors?.presTypeName?.type === "maxLength" && <p className="error-text">Prescription Type Name cannot exceed 50 characters</p>}
                        </div><br />
                        <div>
                            <input 
                                type="checkbox" 
                                id="add-pres-type-show-overview" 
                                {...register("presTypeShowOverview")} 
                            />
                            <label htmlFor="add-pres-type-show-overview" style={{ marginLeft: '10px' }}>Show in Education Tab</label><br />
                        </div>
                    </div>

                    <div>
                        <button type="button" className='btn-filled' style={{ width: 'fit-content', margin: '0px auto 50px auto' }} onClick={handleSubmit(handleAddPresType)}>Add prescription type</button>
                    </div>
                </>}


                {addPopUpContext === 'EDIT_PRES_TYPE' && (
                    <div style={{ padding: '50px 20px', maxWidth: '60vw', minWidth: '30vw' }}>
                        <div style={{ width: '300px' }}>
                        </div>
                        <div className="" style={{ display: 'flex', marginBottom: '1.5vh' }}>
                            <label>Prescription Type Name :</label>
                            <input
                                className="input-field-doctor input-border"
                                type="text"
                                style={{ width: '94%' }}
                                defaultValue={editPresTypeData.presTypeName}
                                onChange={(e) => setEditPresTypeData({ ...editPresTypeData, presTypeName: e.target.value })}
                                required={true}
                                maxLength={50}

                            />
                            {errors?.presTypeName?.type === "required" && <p className="error-text">This field is required</p>}
                            {errors?.presTypeName?.type === "maxLength" && <p className="error-text">Prescription Type Name cannot exceed 50 characters</p>}
                        </div>
                        <div>
                            <input 
                                type="checkbox" 
                                id="edit-pres-type-show-overview" 
                                checked={editPresTypeData.presTypeShowOverview} 
                                onChange={() => setEditPresTypeData({ ...editPresTypeData, presTypeShowOverview: !editPresTypeData.presTypeShowOverview })}
                            />
                            <label htmlFor="edit-pres-type-show-overview" style={{ marginLeft: '10px' }}>Show in Education Tab</label><br />
                        </div>
                        <br />
                        <div>

                            <div
                                className='btn-filled'
                                style={{ width: 'fit-content', margin: '0px auto 50px auto' }}
                                onClick={() => handleEditPresTypeSubmit()}
                            >
                                Save Changes
                            </div>
                        </div>
                    </div>
                )}

{addPopUpContext === "QUESTIONNAIRE" && (
            <div
              style={{
                padding: "22px 9px",
                width: "467px",
                minHeight: "300px",
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                boxSizing: "border-box",
              }}
            >
              <div style={{ textAlign: "center", marginTop: "0px" }}>
                {isEditQuestionnaireClicked ? (
                  <h2>Edit Questionnaire</h2>
                ) : (
                  <h2>Add New Questionnaire</h2>
                )}
              </div>
              <div style={{ marginTop: "10px" }}>
                <label htmlFor="question">Questionnaire:</label>
                <br />
                <br />
                <input
                  type="text"
                  id="question"
                  name="question"
                  style={{
                    marginLeft: "2px",
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "lightgrey",
                    boxSizing: "border-box",
                  }}
                  ref={inputRef}
                  value={selectedQuestionnaire}
                  onChange={handleInputChange}
                />
              </div>
              <br />
              <div style={{ marginTop: "10px" }}>
                <label htmlFor="diagnosis">Diagnosis:</label>
                <br />
                <br />
                <select
                  id="diagnosis"
                  name="diagnosis"
                  style={{
                    marginLeft: "2px",
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "lightgrey",
                    boxSizing: "border-box",
                  }}
                  onChange={handleDiagnosisChange}
                  value={selectedDiagnosis || ""}
                >
                  <option value="" disabled hidden>
                    Select a diagnosis
                  </option>
                  {diagnosisData.map((diagnosis) => (
                    <option key={diagnosis.diagId} value={diagnosis.diagId}>
                      {diagnosis.name}
                    </option>
                  ))}
                </select>
              </div>
              <br />
              <div style={{ marginTop: "10px" }}>
                <input
                  type="checkbox"
                  id="ActiveCheck"
                  name="ActiveCheck"
                  onChange={handleActiveChange}
                  checked={isChecked}
                />
                <label htmlFor="ActiveCheck" style={{ marginLeft: "5px" }}>
                  Active?
                </label>

                <select
                    value={dropdownValue}
                    id ="questionnaireStage"
                    onChange={handleDropdownChange}
                    style={{ marginLeft: '10px', padding: '5px' }}
                  >
                    <option value="Initial">Initial</option>
                    <option value="Followup">Followup</option>
                </select>
                {errorMessage && (
                  <p style={{ color: "red", marginLeft: "5px" }}>
                    {errorMessage}
                  </p>
                )}
              </div>

              <div>
                <div
                  className="btn-filled"
                  style={{
                    width: "fit-content",
                    margin: "0px auto 50px auto",
                  }}
                  onClick={() =>
                    isEditQuestionnaireClicked
                      ? handleEditQuestionnaire()
                      : handleAddQuestionnaireNew()
                  }
                >
                  {isEditQuestionnaireClicked ? "Save" : "Add Questionnaire"}
                </div>
              </div>
            </div>
          )}
          {addPopUpContext === "QUESTION" && (
            <>
              <div
                style={{
                  padding: "15px 15px",
                  maxHeight: "400px",
                  overflowY: "auto",
                }}
              >
                <div style={{ textAlign: "center", marginTop: "0px" }}>
                  <h2>{selectedQuestionnaire} Questionnaire :</h2>
                </div>
                <div style={{ textAlign: "left", marginTop: "0px" }}>
                  {questions.map((questionItem, idx) => {
                    const parentQuestion = questionItem;
                    const childQuestions = questions.filter(
                      (childQuestion) =>
                        childQuestion.parent_question_id ===
                          parentQuestion.qId &&
                        childQuestion.qId !== parentQuestion.qId
                    );
                    const mapValues = Array.from(questionMap.values());
                    const isParentQuestion = mapValues.some((innerArray) =>
                      innerArray.some((obj) => obj.qId === questionItem.qId)
                    );
                    //);
                    if (!isParentQuestion) {
                      return (
                        <div
                          key={parentQuestion.qId}
                          style={{ marginBottom: "20px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <p style={{ marginRight: "10px" }}>
                              {" "}
                              {parentQuestionCounter++}.
                            </p>{" "}
                            <p style={{ flexGrow: 1 }}>
                              {parentQuestion.question}
                            </p>
                            <EditIcon
                              onClick={() =>
                                handleEditQuestion(
                                  parentQuestion.qId,
                                  parentQuestion.question,
                                  parentQuestion.weight
                                )
                              }
                              style={{ cursor: "pointer", marginRight: "10px" }}
                            >
                              Edit
                            </EditIcon>
                            <AdminPopUps
                              data={{
                                action: `delete-question`,
                                step: 1,
                                rowData: {
                                  q_id: parentQuestion.qId,
                                },
                                postDeleteAction: () => {
                                  handleQuestionnaireSelection(
                                    selectedQuestionnaireId,
                                    selectedQuestionnaire
                                  );
                                  setShowAdminPopUps(false);
                                },
                                setParentRefreshStatus: (status) => {
                                  setRefreshStatus(status);
                                  setShowAdminPopUps(false);
                                },
                              }}
                            />
                          </div>
                          {childQuestions.map((childQuestion, childIndex) => (
                            <div
                              key={childQuestion.qId}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "20px",
                              }}
                            >
                              <p style={{ marginRight: "10px" }}>
                                {childIndex + 1}.
                              </p>{" "}
                              <p style={{ flexGrow: 1 }}>
                                {childQuestion.question}
                              </p>
                              <EditIcon
                                onClick={() =>
                                  handleEditQuestion(
                                    childQuestion.qId,
                                    childQuestion.question,
                                    childQuestion.weight
                                  )
                                }
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                }}
                              >
                                Edit
                              </EditIcon>
                              <AdminPopUps
                                data={{
                                  action: `delete-question`,
                                  step: 1,
                                  rowData: {
                                    q_id: childQuestion.qId,
                                  },
                                  postDeleteAction: () => {
                                    handleQuestionnaireSelection(
                                      selectedQuestionnaireId,
                                      selectedQuestionnaire
                                    );
                                    setShowAdminPopUps(false);
                                  },
                                  setParentRefreshStatus: (status) => {
                                    setRefreshStatus(status);
                                    setShowAdminPopUps(false);
                                  },
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      );
                    }
                  })}
                </div>
                <div>
                  <div
                    className="btn-filled"
                    style={{
                      width: "fit-content",
                      margin: "0px auto 50px auto",
                    }}
                    onClick={() => handleAddQuestion()}
                  >
                    Add Question
                  </div>
                </div>
              </div>
            </>
          )}
            </Popup>
            <Popup
        open={openInnerPopUp}
        modal
        closeOnDocumentClick={false}
        onClose={handleClosePopup}
        className="congrats-popup"
        contentStyle={{
          width: "70%",
          height: "70vh",
          overflowY: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            padding: "20px",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              cursor: "pointer",
            }}
            onClick={handleClosePopup}
          >
            <span className="material-symbols-outlined">close</span>
          </div>
          {isAddQuestionClicked && (
            <>
              <div
                style={{
                  padding: "22px 9px",
                  width: "900px",
                  minHeight: "300px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                  boxSizing: "border-box",
                }}
              >
                <div style={{ textAlign: "center", marginTop: "0px" }}>
                  <h2>Add New Question</h2>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <label htmlFor="question">Question:</label>
                  <br />
                  <input
                    type="text"
                    id="question"
                    name="question"
                    style={{
                      marginLeft: "5px",
                      width: "70%",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      backgroundColor: "lightgrey",
                      boxSizing: "border-box",
                    }}
                    placeholder="Enter question"
                    ref={inputRef}
                  />
                  <input
                    type="number"
                    style={{
                      marginLeft: "5px",
                      width: "18%",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      backgroundColor: "lightgrey",
                      boxSizing: "border-box",
                      position: "relative"
                    }}
                    value={questionWeight || ""}
                    onChange={(e) => handleQuestionWeightChange(e)}
                    placeholder="Enter weight"
                  />
                </div>

                <div style={{ marginTop: "10px"}}>
                  <div style={{ marginBottom: "5px" }}>
                    Add Options :
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <input
                      type="text"
                      value={customOption}
                      onChange={(e) => setCustomOption(e.target.value)}
                      style={{ marginRight: "10px", borderRadius: "4px" }}
                      placeholder="Enter custom options"
                    />
                    <input
                      type="number"
                      value={optionWeight || ""}
                      onChange={(e) => handleAddOptionWeight(e)}
                      style={{ marginRight: "10px", width: "10%", borderRadius: "4px" }}
                      placeholder="Weight"
                    />
                    <button onClick={handleAddCustomOption} className="btn-filled">Add Option</button>
                  </div>

                  {customOptions.length > 0 && (
                    <div style={{ marginBottom: "10px" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        Options Added:
                      </div>
                      {customOptions.map((custom, index) => (
                        <div key={index} style={{ marginBottom: "5px" }}>
                          <span style={{ fontWeight: "bold" }}>
                            {index + 1}.{" "}
                          </span>
                          {custom}
                        </div>
                      ))}
                    </div>
                  )}
                  {optionsList != null && optionsList.length > 0 && (
                    <div style={{ marginBottom: "10px" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        Options Selected:
                      </div>
                      {optionsList.map((option, index) => (
                        <div key={index} style={{ marginBottom: "5px" }}>
                          <span style={{ fontWeight: "bold" }}>
                            {index + 1}.{" "}
                          </span>
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {errorMessage && (
                  <div style={{ textAlign: 'center', color: "red"}}>
                      {errorMessage}
                  </div>
                )}
                <div
                  style={{
                    width: "fit-content",
                    margin: "20px auto 50px auto",
                  }}
                >
                  <button
                    onClick={handleAddQuestionInner}
                    className="btn-filled"
                  >
                    Add Question
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Popup>
      <Popup
        open={isEditQuestionClicked}
        modal
        closeOnDocumentClick={false}
        onClose={handleCloseEditPopup}
        className="congrats-popup"
        contentStyle={{
          width: "70%",
          height: "70vh",
          overflowY: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            padding: "20px",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              cursor: "pointer",
            }}
            onClick={handleCloseEditPopup}
          >
            <span className="material-symbols-outlined">close</span>
          </div>
          {isEditQuestionClicked && (
            <>
              <div
                style={{
                  padding: "22px 9px",
                  width: "467px",
                  minHeight: "300px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                  boxSizing: "border-box",
                }}
              >
                <div style={{ textAlign: "center", marginTop: "0px" }}>
                  <h2>Edit Question</h2>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <label htmlFor="question">Question:</label>
                  <br />
                  <input
                    type="text"
                    id="question"
                    name="question"
                    style={{
                      marginLeft: "5px",
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      backgroundColor: "lightgrey",
                      boxSizing: "border-box",
                    }}
                    value={selectedQuestion}
                    ref={inputRef}
                    onChange={handleQuestionChange}
                  />
                </div>
                <div style={{ marginTop: "10px" }}>
                  <label htmlFor="questionWeight">Question Weight:</label>
                    <input
                      type="text"
                      id="questionWeight"
                      name="questionWeight"
                      style={{
                        marginLeft: "5px",
                        width: "10%",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        backgroundColor: "lightgrey",
                        boxSizing: "border-box",
                      }}
                      value={questionWeight || ""}
                      onChange={(e) => handleQuestionWeightChange(e)}
                    />
                </div>
                <br />

                {questionOptions != null && questionOptions.length > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                      Options:
                    </div>
                    {questionOptions.map((option, index) => (
                      <div key={index} style={{ marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{ fontWeight: "bold", marginRight: "5px" }}
                          >
                            {index + 1}.
                          </div>

                          <div>
                            <input
                              type="text"
                              id="option"
                              name="option"
                              onChange={(e) => handleOptionNameChange(e, option.oId)}
                              style={{
                                fontWeight: "bold",
                                marginRight: "5px",
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                backgroundColor: "lightgrey",
                                padding: '5px'
                              }}
                              value={option.optionName}
                            />
                          </div>
                          <div
                            style={{ fontWeight: "bold", marginRight: "5px" }}
                          >
                            Weight:
                          </div>
                          <div style={{ width: '9%' }}>
                            <input
                              type="text"
                              id="weight"
                              name="weight"
                              onChange={(e) => handleOptionWeightChange(e, option)}
                              style={{
                                fontWeight: "bold",
                                marginRight: "5px",
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                backgroundColor: "lightgrey",
                                padding: '5px',
                                width: '100%'
                              }}
                              value={option.weight ? option.weight : "" }
                            />
                          </div>

                          <button
                            onClick={() =>
                              // oId, the field every other part of this screen and the
                              // follow-up map use. It read option.oid, which options
                              // created here do not have, so the follow-up was filed
                              // under undefined and never appeared after its answer.
                              handleAddFollowUpQuestion(questionId, option.oId)
                            }
                            style={{
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              border: "1px solid #ccc",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              marginLeft: "10px",
                            }}
                          >
                            <span style={{ fontSize: "12px" }}>+</span>
                          </button>
                        </div>

                        <div style={{ marginTop: "5px", marginLeft: "20px" }}>
                          Follow Ups:
                          {isFollowUp &&
                            followUpQuestions.has(option.oId) &&
                            followUpQuestions
                              .get(option.oId)
                              .map((followUpQuestion, idx) => (
                                <div key={idx} style={{ marginLeft: "15px" }}>
                                  {idx + 1}. {followUpQuestion}
                                </div>
                              ))}
                        </div>
                        <br />
                      </div>
                    ))}
                  </div>
                )}

                {errorMessage && (
                  <div style={{ textAlign: 'center', color: "red"}}>
                      {errorMessage}
                  </div>
                )}

                <div
                  style={{
                    width: "fit-content",
                    margin: "20px auto 50px auto",
                  }}
                >
                  <button
                    onClick={handleSaveEditQuestion}
                    className="btn-filled"
                  >
                    Save
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Popup>
        </div>
    )

};

export default AdminMaintainenceList;